import React from 'react';
import '../assets/css/TrustBanner.css';

const VerifiedBadge = () => (
    <svg viewBox="0 0 24 24" width="20" height="20" style={{ marginRight: "8px", verticalAlign: "middle", display: "inline-block" }}>
        <path fill="#1877F2" d="M12,2C6.477,2,2,6.477,2,12c0,5.523,4.477,10,10,10s10-4.477,10-10C22,6.477,17.523,2,12,2z"></path>
        <path fill="#ffffff" d="M10.47,16.59L6.15,12.26l1.41-1.41l2.91,2.91l6.97-6.97l1.41,1.41L10.47,16.59z"></path>
    </svg>
);

const TrustBanner = () => {
    return (
        <section className="trust-banner-section">
            <div className="trust-banner-container">
                <p className="trust-banner-text">Fully Compliant & Powered by Official APIs</p>
                <div className="trust-banner-badges">
                    <div className="trust-badge">
                        <VerifiedBadge />
                        <span>Meta Verified Tech Provider</span>
                    </div>
                    <div className="trust-badge">
                        <VerifiedBadge />
                        <span>YouTube API Services Developer</span>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TrustBanner;
